import { BaseApi } from "../shared/api";
import * as types from "./actionTypes";
import * as url from "./apiUrls";

export function checkUnreadNotifications() {
  return (dispatch, getState) => {
    const api = new BaseApi(dispatch, getState);
    const { user } = getState();

    api.getRequest(
      url.unreadNotifications(user.id),
      response => {
        dispatch({
          type: types.CHECK_UNREAD_NOTIFICATIONS,
          payload: response.data.unread_notifications,
        });
      }
    )
  }
}

export function newNotification() {
  return (dispatch) => {
    dispatch({type: types.NEW_NOTIFICATION});
  }
}

export function actionCenterClick(id, onSuccess = () => {}) {
  return (dispatch, getState) => {
    const api = new BaseApi(dispatch, getState);
    const { user } = getState();

    api.getRequest(
      url.actionCenterClick(user.id, id),
      response => {
        dispatch(checkUnreadNotifications());
        dispatch({ type: types.ACTION_CENTER_CLICKED }); // logs action on store
        onSuccess(response)
      }
    )
  }
}

// type == active_center_show / update_center_show
export function fetchNotifications(type) {
  return (dispatch, getState) => {
    const api = new BaseApi(dispatch, getState);
    const { user } = getState();

    api.getRequest(
      url.notifications(user.id, type),
      response => {
        dispatch({
          type: types.FETCH_NOTIFICATIONS,
          payload: response.data,
        });
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/notifications/actions.js